import cssVariables from 'tfs.css-variables'

export default {
  button: {
    display: 'inline-flex',
    backgroundColor: 'transparent',
    border: 'none',
    borderBottom: '1px solid transparent',
    color: cssVariables.colorGreen,
    fontSize: 'inherit',

    '&:hover, &:active, &:focus': {
      border: 'none',
      cursor: 'pointer',
      outline: 'none',
      borderBottom: `1px solid ${cssVariables.colorGreen}`,
    },

    '&[disabled]': {
      color: cssVariables.colorGrayD,
      '&:hover, &:active, &:focus': {
        borderBottom: '1px solid transparent',
        cursor: 'default',
      },
    },
  },
}
